import {Injectable} from '@angular/core';
import {User} from './user.model';
import {HttpMethod, Service} from '../common/service.class';
import {UserModelService} from '../common/user-model.service';
import {Observable} from 'rxjs';
import {URLSearchParams} from '@angular/http';
import {Page} from '../common/search/page.class';
import {Profile} from '../profile/profile.model';

//region Other Classes
export class UserAndProfileProjection {
    user: User;
    profile: Profile;
}

export class UserSearchQueryData {
    text: string;
    page: number;
    pageSize: number;
    filter: string;
    status: string;
    from: string;
    to: string;
    recredentialed: boolean;
}

export class UserSearchQuery extends UserSearchQueryData {
    constructor(data: Readonly<UserSearchQueryData>) {
        super();
        Object.assign(this, data);
    }

    asParams(): URLSearchParams {
        const params = new URLSearchParams();
        params.set('text', this.text);
        params.set('page', this.page.toString());
        params.set('pageSize', this.pageSize.toString());
        params.set('filter', this.filter);
        params.set('status', this.status);
        params.set('from', this.from );
        params.set('to', this.to);
        params.set('recredentialed', this.recredentialed.toString());
        return params;
    }
}

export const UserSearchFilters = {
    FIRST_NAME: 'FIRST_NAME',
    LAST_NAME: 'LAST_NAME',
    MOBILE_PHONE: 'MOBILE_PHONE',
    EMAIL: 'EMAIL',
    NPI: 'NPI',
    STATE_LICENSED: 'STATE_LICENSED',
    SPECIALTY: 'SPECIALTY',
    STATUS: 'STATUS'
};

export const StatusFilters = {
    IN_PROCESS: 'IN_PROCESS',
    CANCELLED: 'CANCELLED',
    ON_HOLD: 'ON_HOLD',
    COMPLETE: 'COMPLETE',
    EXPIRED: 'EXPIRED',
    NOT_APPROVED: 'NOT_APPROVED'
};

//endregion

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class UserService extends UserModelService<User> {

    private _service: Service;

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'user', User);
        this._service = new Service(svcm, this.namespace);
    }

    createCurrentUserIfAbsent(): Observable<boolean> {
        return this._service.getScalarValue('currentUser/createIfAbsent', undefined, true);
    }

    createUser(model: UserAndProfileProjection): Observable<User> {
        return this._service.call('createWithProfile', undefined, model, HttpMethod.POST, true)
            .map(res => new User(res.json()));
    }

    search(query: UserSearchQuery): Observable<Page<User>> {
        return this._service.getPage(User, 'search', undefined, query.asParams());
    }

    verifyEmailChange(token: string): Observable<Boolean> {
        return this._service.call('verifyEmailChange', undefined, {token: token}, HttpMethod.PUT, true)
            .map(() => true);
    }

    resendEmailChangeVerificationForCurrentUser(): Observable<Boolean> {
        return this._service.call('resendEmailChangeVerification/currentUser', undefined, undefined, HttpMethod.PUT)
            .map(() => true);
    }

    cancelEmailChangeForCurrentUser(): Observable<Boolean> {
        return this._service.call('cancelEmailChange/currentUser', undefined, undefined, HttpMethod.PUT)
            .map(() => true);
    }

    sendSetPasswordEmail(userId: string): Observable<boolean> {
        const params = new URLSearchParams();
        params.set('id', userId);
        return this._service.call('sendSetPasswordEmail', params, undefined, HttpMethod.PUT)
            .map(() => true);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/user/user.service.ts